const appIcons = {
  shoppingCartIcon: require("./icons/shopping-cart-icon.png"),
  whiteSmsIcon: require("./icons/white-sms-icon.png"),
  locationIcon: require("./icons/location-icon.png"),
  calendarCheckIcon: require("./icons/calendar-check-icon.png"),
  checkOrangeRedIcon: require("./icons/check-orange-red-icon.png"),
  cashBlackIcon: require("./icons/cash-black-icon.png"),
  whiteArrowBackIcon: require("./icons/white-arrow-back-icon.png"),
  addCartBtnIcon: require("./icons/add-cart-grey-icon.png"),
  orangeRedCartIcon: require("./icons/orange-red-cart-icon.png"),
  deleteIcon: require("./icons/delete-icon.png"),
  editIcon: require("./icons/edit-mustard-icon.png"),
  greyPinIcon: require("./icons/grey-pin-icon.png"),

  // Black Icon
  blackBankIcon: require("./icons/black-bank-icon.png"),
  blackRightArrowIcon: require("./icons/black-right-arrow-icon.png"),
  blackDashboardIcon: require("./icons/black-dashboard-icon.png"),
  blackLeftArrowIcon: require("./icons/black-left-arrow-icon.png"),
  blackFilterIcon: require("./icons/black-filter-icon.png"),
  blackCartIcon: require("./icons/black-cart-icon.png"),
  blackSortAscendingIcon: require("./icons/black-sort-ascending-icon.png"),
  blackHeadphoneIcon: require("./icons/black-headphone-icon.png"),
  blackNotificationIcon: require("./icons/black-notification-icon.png"),

  // Purple icon
  purpleNotificationIcon: require("./icons/purple-notification-icon.png"),
  purpleEdIcon: require("./icons/purple-ed-icon.png"),
  purpleCartIcon: require("./icons/purple-cart-icon.png"),
  purpleServiceIcon: require("./icons/purple-service-icon.png"),
  purpleUserIcon: require("./icons/purple-user-icon.png"),
  purpleNotification1Icon: require("./icons/purple-notification-1-icon.png"),
  purpleCustomerSupportIcon: require("./icons/purple-cs-icon.png"),
  purpleFeesIcon: require("./icons/purple-fee-icon.png"),
  purpleReportCardIcon: require("./icons/purple-report-card-icon.png"),
  purpleDeliveredIcon: require("./icons/purple-delivered-icon.png"),
  purpleTimeTableIcon: require("./icons/purple-time-table-icon.png"),
  purpleChatIcon: require("./icons/purple-chat-icon.png"),
  purpleBackArrowIcon: require("./icons/purple-back-arrow-icon.png"),
  purpleSigleArrowRightIcon: require("./icons/purple-single-arrow-right-icon.png"),
  purpleLogoutIcon: require("./icons/purple-logout-icon.png"),
  purpleSmileIcon: require("./icons/purple-smile-icon.png"),
};

const appImages = {
  // Service Images
  serviceCookingImg: require("./images/service-cooking-img.png"),
  serviceCleaningImg: require("./images/service-cleaning-img.png"),
  serviceLaundaryImg: require("./images/service-laundary-img.png"),
  serviceCarCleaningImg: require("./images/service-car-cleaning-img.png"),
  serviceWaiterImg: require("./images/service-waiter-img.png"),
  servicePoolCleaningImg: require("./images/service-pool-cleaning-img.png"),
  serviceCleaningMainImage: require("./images/cleaning-main-image.png"),

  // How it works image
  hwWorkImg: require("./images/hw-work-img.png"),
  hwProfileImg: require("./images/hw-profile-img.png"),
  hwGirlImg: require("./images/hw-girl-img.png"),
  hwCleaningImg: require("./images/workers-images.jpeg"),
  hwMobileImg: require("./images/hw-mobile-img.png"),
  studentCelebrationImage: require("./images/student-celebration-img.png"),
  videoPlayImage: require("./images/video-play-img.png"),
  paymentCardImage: require("./images/payment-card-image.jpeg"),
  makePayment: require("./images/make-payment.jpg"),
  meetNewWorkers: require("./images/meet-new-workers.jpg"),
  receivedYourProduct: require("./images/Received-you-product.jpg"),
  registerOnThePlatform: require("./images/Register-on-the platform.jpg"),
  selectServiceProduct: require("./images/select-services-product.jpg"),

  // Category Images
  catgoryCleaningImg: require("./images/category-cleaning-img.png"),
  catgoryStationaryImg: require("./images/category-stationary-img.png"),
  catgoryCarSkeletonImg: require("./images/category-vehicle-skeleton-img.png"),
  catgoryMixProductImg: require("./images/category-mix-product-img.png"),
  catgoryCrockeryImg: require("./images/category-crockery-img.png"),
  catgoryElectrniceImg: require("./images/category-electronics-img.png"),

  // App and play store link image
  playStoreImg: require("./images/play-store-btn.png"),
  appStoreImg: require("./images/app-store-btn-img.png"),

  // Free Trial Images
  trialImage1: require("./images/free-trail-1-img.png"),
  trialImage2: require("./images/free-trail-2-img.png"),
  trialImage3: require("./images/free-trail-3-img.png"),
  trialImage4: require("./images/free-trail-4-img.png"),

  // Product Images
  productImage1: require("./images/product-1-img.png"),
  productImage2: require("./images/product-2-img.png"),
  productImage3: require("./images/product-3-img.png"),
  productImage4: require("./images/product-4-img.png"),
  productImage5: require("./images/product-5-img.png"),
  productImage6: require("./images/product-6-img.png"),
  productImage7: require("./images/product-7-img.png"),
  productImage8: require("./images/product-8-img.png"),
  productImage9: require("./images/product-9-img.png"),
  productImage10: require("./images/product-10-img.png"),
  productImage11: require("./images/product-11-img.png"),
  productImage12: require("./images/product-12-img.png"),
  productImage13: require("./images/product-13-img.png"),
  productImage14: require("./images/product-14-img.png"),
  productImage15: require("./images/product-15-img.png"),
  productImage16: require("./images/product-16-img.png"),

  // Background images
  helpPageBgImg: require("./images/pricing-bg.webp"),
  serviceBgImg1: require("./images/service-bg-1-img.png"),
  noProductFoundImg: require("./images/no-product-found-img.png"),
  noProductFoundNewImg: require("./images/no-product-found-img-new.png"),

  // Waves
  helpPageWaveImg: require("./images/help-page-wave-img.png"),

  // Authentication
  authBg: require("./images/auth-bg.png"),

  // Business image
  business1Img: require("./images/business-1-img.png"),
  business2Img: require("./images/business-2-img.png"),

  // Detail page bg
  educationCityDetailBg: require("./images/education-page-bg.png"),
  pdDetailBgImg: require("./images/pd-detail-bg-img.jpg"),

  // Stepper image
  stepperStepOneImg: require("./images/stepper-step-1-img.png"),
  stepperStepTwoImg: require("./images/stepper-step-2-img.png"),
  stepperStepThreeImg: require("./images/stepper-step-3-img.png"),

  // DumyImges
  schoolBoyImage: require("./images/school-boy-image.png"),

  // Waitlist Bg Image
  waitlistBgImg: require("./images/join-waitlist-bg.jpg"),
  // Faq Bg Image
  faqBgImage: require("./images/faq-bg.webp"),
  // cleaning Bg Image
  cleaningBgImg: require("./images/cleaning-bg.jpg"),
  // car service Bg Image
  carServiceBgImg: require("./images/car-service-bg.jpg"),
  // Comming Soon
  commingSoon: require("./images/comming-soon.webp"),
  // Anpc
  anpcImage: require("./images/logo-anpc.png"),
  // Litigiu
  litigiuImage: require("./images/logo-litigiu.png"),
};

const appSvg = {
  servicerProductBgSvg: require("./svg/service-product-bg.svg"),
  // Cleaning svgs
  guestHouseCleaningSvg: require("./svg/guest-house-cleaning.svg").default,
  communityCleaningSvg: require("./svg/community-cleaning.svg").default,
  intituteCleaningSvg: require("./svg/institutional-cleaning.svg").default,
  venueCleaningSvg: require("./svg/venue-cleaning.svg").default,
  houseCleaningSvg: require("./svg/house-cleaning.svg").default,
  industryCleaningSvg: require("./svg/industrial-cleaning.svg").default,
  blackCleaningSvg: require("./svg/block-cleaning.svg").default,
  shopCleaningSvg: require("./svg/office-cleaning.svg").default,
  officeCleaningSvg: require("./svg/shop-cleaning.svg").default,
  // Car Service svgs
  carWashSvg: require("./svg/car-wash.svg").default,
  generalMechanicSvg: require("./svg/general-mechanic.svg").default,
  generalServiceSvg: require("./svg/general-servicing.svg").default,
  tyreServiceSvg: require("./svg/tyre-servicing.svg").default,
  carInspectionSvg: require("./svg/car-inspection.svg").default,
  // E Commere svgs
  vegetableSvg: require("./svg/vegetable.svg").default,
  fruitsSvg: require("./svg/fruits.svg").default,
  fashionApparelSvg: require("./svg/fashion-apparel.svg").default,
  sportsOutdoorSvg: require("./svg/sports-outdoor.svg").default,
  beautyPersonalSvg: require("./svg/beauty-personal.svg").default,
  homeLivingSvg: require("./svg/home-living.svg").default,
  stationarySvg: require("./svg/stationary.svg").default,
  utensilsCrockerySvg: require("./svg/utensils-crockery.svg").default,
  electronicsSvg: require("./svg/electronics.svg").default,
  vehiclePartsSvg: require("./svg/vehicle-parts.svg").default,
  cleaningProductSvg: require("./svg/cleaning-product.svg").default,
};

const appLogo = {
  dashboardLogo: require("./images/MRK-logo.png"),
  blueTelegramLogo: require("./icons/blue-telegram-logo.png"),
  googleLogo: require("./icons/google-color-icon.png"),
  facebookLogo: require("./icons/facebook-color-icon.png"),
  serviceProviderLogo: require("./svg/eaziday-logo.svg").default,
};

const appVideo = {
  homePageVideo: require("./videos/eaziday-video.mp4"),
};

export { appIcons, appImages, appSvg, appLogo, appVideo };
